/* DrinksNation delivery slot picker (S4-04; v1.1 §5.2, §6.2; BUILD_PLAN "Planned: delivery slot chooser",
   FairPrice Online's sheet as the reference). Cart page only, loaded from layout/theme.liquid after
   dn-cart.js. The frame is snippets/dn-slot-picker.liquid; this file fills and drives it.
   - GET /apps/dn/slots?postal=&cartons= (the Brain through the app proxy) → a Mon–Sun calendar where each
     day that has a window is a button and every other date is greyed (10 Sep 2026); window rows, a full one greyed "Not available"; a window we never run in a zone is
     simply absent (never greyed). Continue POSTs /apps/dn/slots/hold (15 minutes); step two takes the
     delivery details; Confirm writes the Brain's reply attributes verbatim (dn_slot_id, dn_slot_label,
     dn_hold_id, dn_hold_expires_at, dn_zone) and ours (dn_postal, dn_slot_cartons, dn_allow_earlier and the
     desktop cart's four driver notes dn_note_leave, dn_note_lift, dn_note_bay, dn_note_hours) with one
     /cart/update.
   - When the cartons change (dn:cart from dn-cart.js) it asks the Brain again with the new count and
     the hold is resized; when the hold runs out it asks again; a refusal clears the slot and says why.
   - Cancelling the sheet after Continue, or confirming a different window, hands the first window back at
     once (POST /apps/dn/slots/release) rather than leaving it held for the rest of its quarter hour.
   - The block carries two lines. The slot line appears only when the Brain offers windows. **The driver
     notes are always there** (8 Sep 2026: "always visible, drawer too"): they are cart attributes
     and need nothing from the Brain, so a shopper happy with the 3–5 working day promise can still say
     "leave it at the door" without booking a window they did not want. Their button opens the same details
     step on its own, takes no hold, and Confirm writes only the notes. On the cart page and in the drawer
     both. With JS off neither line shows and the cart still checks out.
   Loaded on the cart page and on every page that can open the drawer (8 Sep 2026: the row and the
   sheet live in the drawer too, so the phone's basket carries the driver notes).
   Vanilla JS, no framework. The pure helpers are exported for node: qa/unit/dn-slots.test.mjs. */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.dnSlots = api;
  if (typeof document !== 'undefined' && typeof fetch === 'function') api.boot();
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  var SG = 'Asia/Singapore';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var BRAIN_ATTRS = ['dn_slot_id', 'dn_slot_label', 'dn_hold_id', 'dn_hold_expires_at', 'dn_zone']; // the reply, verbatim
  var REASONS = {
    no_capacity: 'That window just filled up. Pick another.',
    past_cutoff: 'That window has closed. Pick another.',
    closed: 'That window has closed. Pick another.',
    not_found: 'That window is no longer offered. Pick another.'
  };
  var PROMISE = 'Or leave it to us: delivered within 3–5 working days.';

  /* ---------- pure ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /** "2026-09-10" → "Thu, 10 Sep", the chip (FairPrice's "Wed, 9 Sep"). Month from a table, so never "Sept". */
  function dayLabel(isoDay) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDay || '')); if (!m) return '';
    var d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }
  var LONG_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var LONG_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAY_MS = 86400000;
  function utcOf(isoDay) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDay || '')); return m ? Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : NaN; }
  function isoOf(ms) { return new Date(ms).toISOString().slice(0, 10); }
  /**
   * The offered days as a calendar, Monday to Sunday (10 Sep 2026: "can this be kept to a
   * calendar with sunday greyed out"). It runs from the Monday of the first offered day's week to the
   * Sunday of the last one's, so every row is a whole week and no row is all grey. A cell's `index` is
   * its position in `days` - the day index the sheet already works in - or -1 when that date is not
   * offered: a Sunday, a public holiday, a day past the horizon, or before the lead in the first week.
   * [] when nothing is offered or a date is unreadable.
   */
  function calendarWeeks(days) {
    if (!days || !days.length) return [];
    var at = {}, lo = Infinity, hi = -Infinity;
    for (var i = 0; i < days.length; i++) {
      var t = utcOf(days[i] && days[i].day); if (!isFinite(t)) return [];
      at[isoOf(t)] = i; lo = Math.min(lo, t); hi = Math.max(hi, t);
    }
    var from = lo - ((new Date(lo).getUTCDay() + 6) % 7) * DAY_MS;  // back to Monday
    var to = hi + (6 - (new Date(hi).getUTCDay() + 6) % 7) * DAY_MS; // on to Sunday
    var weeks = [], week = [];
    for (var ms = from; ms <= to; ms += DAY_MS) {
      var d = new Date(ms), iso = isoOf(ms);
      week.push({ day: iso, date: d.getUTCDate(), month: d.getUTCMonth(), year: d.getUTCFullYear(), weekday: d.getUTCDay(), index: iso in at ? at[iso] : -1 });
      if (week.length === 7) { weeks.push(week); week = []; }
    }
    return weeks;
  }
  /** The calendar's caption: "September 2026", or "September – October 2026" when it crosses a month,
      "December 2026 – January 2027" when it crosses a year. */
  function calendarTitle(weeks) {
    if (!weeks || !weeks.length) return '';
    var a = weeks[0][0], b = weeks[weeks.length - 1][6];
    if (a.year !== b.year) return LONG_MONTHS[a.month] + ' ' + a.year + ' – ' + LONG_MONTHS[b.month] + ' ' + b.year;
    if (a.month !== b.month) return LONG_MONTHS[a.month] + ' – ' + LONG_MONTHS[b.month] + ' ' + b.year;
    return LONG_MONTHS[a.month] + ' ' + a.year;
  }
  /** "Monday, 14 September", what a screen reader hears for a date cell. */
  function dayLongLabel(isoDay) {
    var t = utcOf(isoDay); if (!isFinite(t)) return '';
    var d = new Date(t); return LONG_DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + LONG_MONTHS[d.getUTCMonth()];
  }
  /**
   * Where an arrow key moves the one tab stop. The stops are "No preference" (-1, on top) and then the
   * offered days in date order. Left and Right step through that order and wrap. Down and Up move a week
   * when the same weekday is offered there; Up from a day with nothing offered above it goes to "No
   * preference", which is the thing above the grid; Down from "No preference" goes to the first day.
   * Returns the new index, or undefined for a key that is not ours.
   */
  function arrowTarget(days, current, key) {
    var n = days ? days.length : 0; if (!n) return undefined;
    if (key === 'ArrowRight' || key === 'ArrowLeft') {
      var order = [-1]; for (var i = 0; i < n; i++) order.push(i);
      var at = order.indexOf(current); if (at < 0) at = 0;
      return order[(at + (key === 'ArrowRight' ? 1 : order.length - 1)) % order.length];
    }
    if (key !== 'ArrowDown' && key !== 'ArrowUp') return undefined;
    if (current < 0 || current >= n) return key === 'ArrowDown' ? 0 : current;
    var want = isoOf(utcOf(days[current].day) + (key === 'ArrowDown' ? 7 : -7) * DAY_MS);
    for (var j = 0; j < n; j++) if (days[j].day === want) return j;
    return key === 'ArrowUp' ? -1 : current;
  }
  /** The Brain's reply → the days worth a chip. Days with no window are dropped (hidden, not greyed);
      a window that cannot take this basket stays, greyed, as FairPrice greys a full slot. Null when the
      reply is not a list of days, which is how "the Brain is away" reads. */
  function offer(reply) {
    if (!reply || typeof reply !== 'object' || !Array.isArray(reply.days)) return null;
    var days = reply.days.filter(function (d) { return d && Array.isArray(d.slots) && d.slots.length > 0; }).map(function (d) {
      return {
        day: String(d.day || ''), label: dayLabel(d.day),
        slots: d.slots.map(function (s) { return { id: String(s.id), window: String(s.window || ''), label: String(s.label || ''), canHold: s.canHold === true }; })
      };
    });
    return { zone: String(reply.zone || ''), driverNote: String(reply.driverNote || ''), days: days };
  }
  /** Where the sheet opens: on the chosen slot when it is still offered (its day, itself selected), else
      the first day with room and nothing selected, so Continue waits for a choice. */
  function firstOpen(o, chosenId) {
    if (!o || !o.days.length) return { dayIndex: 0, slotId: null };
    for (var i = 0; i < o.days.length; i++) {
      for (var j = 0; j < o.days[i].slots.length; j++) {
        var s = o.days[i].slots[j];
        if (chosenId && s.id === chosenId && s.canHold) return { dayIndex: i, slotId: s.id };
      }
    }
    for (var k = 0; k < o.days.length; k++) {
      if (o.days[k].slots.some(function (s) { return s.canHold; })) return { dayIndex: k, slotId: null };
    }
    return { dayIndex: 0, slotId: null };
  }
  function held(attrs) { return !!(attrs && attrs.dn_slot_id); }
  /** A live hold for a different carton count must be re-held (v1.1 §6.2: cartons changed → re-hold). */
  function needsRehold(attrs, cartons) { return held(attrs) && cartons > 0 && Number(attrs.dn_slot_cartons) !== cartons; }
  /** "Allow earlier delivery · Leave at the door · No lift access · Loading bay B · Mon–Fri 9am–6pm" under the
      slot: the answers in the order the sheet asks them (the desktop cart's four notes, 8 Sep 2026). */
  function detailsText(attrs) {
    var out = [];
    if (attrs && attrs.dn_allow_earlier === 'yes') out.push('Allow earlier delivery');
    if (attrs && attrs.dn_note_leave === 'yes') out.push('Leave at the door');
    if (attrs && attrs.dn_note_lift === 'none') out.push('No lift access');
    if (attrs && attrs.dn_note_bay) out.push(String(attrs.dn_note_bay));
    if (attrs && attrs.dn_note_hours) out.push(String(attrs.dn_note_hours));
    return out.join(', ');
  }
  /** Milliseconds until the hold ends; 0 when past or unreadable. */
  function remainingMs(expiresAt, nowMs) { var t = Date.parse(expiresAt || ''); return isFinite(t) ? Math.max(0, t - nowMs) : 0; }
  /** "10:42" in Singapore, for "Held for you until 10:42". */
  function clock(iso) {
    var t = Date.parse(iso || ''); if (!isFinite(t)) return '';
    return new Intl.DateTimeFormat('en-GB', { timeZone: SG, hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(t));
  }
  function reasonText(code) { return REASONS[code] || 'We could not hold that window. Pick another.'; }
  /** What the row shows: 'held' (a slot on the cart), 'offered' (the Brain has days), 'notes' (no slots to
      offer, or the Brain away: the driver details still work, 8 Sep 2026), 'hidden' (the Brain not yet
      asked, so nothing flickers). A saved postal code with no days is 'notes'; no postal code yet is 'offered'
      (the sheet asks for it). */
  function rowMode(attrs, brain, offer, postal) {
    if (held(attrs)) return 'held';
    if (brain === 'unknown') return 'hidden';
    if (brain === 'ok' && (!postal || (offer && offer.days.length > 0))) return 'offered';
    return 'notes';
  }
  var NOTES_PROMPT = 'Leave at the door, no lift access, a loading bay or office hours.';

  /* ---------- DOM ---------- */
  var cfg = root.dnConfig || {};
  var PROXY = cfg.brainProxy || '/apps/dn';
  var KEY = 'dn.postal';
  var state = { attrs: {}, cartons: 0, postal: null, offer: null, dayIndex: 0, slotId: null, pending: null, token: null, brain: 'unknown', mode: 'hidden', notesOnly: false, opener: null, checkoutAfter: false, checkoutButton: null };
  var expiryTimer = null, reholdTimer = null;
  function warn(e) { if (root.console) console.warn('dn-slots:', e && e.message ? e.message : e); }
  function $(sel, from) { return (from || document).querySelector(sel); }
  function $$(sel, from) { return Array.prototype.slice.call((from || document).querySelectorAll(sel)); }
  function block() { return $('[data-dn-slot]'); }
  function sheet() { return $('[data-dn-slot-sheet]'); }
  function announce(text) { var el = $('[data-dn-cart-status]'); if (el) el.textContent = text; }

  function readAttrs() {
    var a = {};
    $$('[data-dn-slot-attr]').forEach(function (i) { var m = /^attributes\[(.+)\]$/.exec(i.name); if (m) a[m[1]] = i.value || ''; });
    return a;
  }
  function writeInputs(attrs) {
    $$('[data-dn-slot-attr]').forEach(function (i) { var m = /^attributes\[(.+)\]$/.exec(i.name); if (m && m[1] in attrs) i.value = attrs[m[1]] == null ? '' : String(attrs[m[1]]); });
  }
  function savedPostal() {
    var v = null; try { v = localStorage.getItem(KEY); } catch (e) { /* private mode */ }
    if (v && /^\d{6}$/.test(v)) return v;
    return /^\d{6}$/.test(state.attrs.dn_postal || '') ? state.attrs.dn_postal : null;
  }
  function savePostal(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ } }
  /* Van cartons, not the header count: a partner's cartons take no slot capacity (ADR-025). */
  function cartonsNow() { var c = root.dnCart; if (!c) return 0; try { return (c.vanCartons || c.cartons)(c.readData(document).lines); } catch (e) { return 0; } }

  /* ---------- the Brain and the cart ---------- */
  function jsonOf(r) { return r.json().then(function (j) { return { status: r.status, body: j }; }, function () { return { status: r.status, body: null }; }); }
  function getSlots(params) {
    var qs = Object.keys(params).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
    return fetch(PROXY + '/slots?' + qs, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' }).then(jsonOf);
  }
  function token() {
    if (state.token) return Promise.resolve(state.token);
    return fetch((cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (c) { state.token = c.token; return c.token; });
  }
  function postHold(slotId, cartons) {
    return token().then(function (t) {
      return fetch(PROXY + '/slots/hold', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ slotId: slotId, cartToken: t, cartons: Math.max(1, cartons) })
      }).then(jsonOf);
    });
  }
  /** Hand a window back before its 15 minutes are up (8 Sep 2026): the shopper cancelled, or moved to
      another one. Best effort — the sweep frees it anyway, so a failure here is never shown. */
  function postRelease(slotId) {
    if (!slotId) return Promise.resolve();
    return token().then(function (t) {
      return fetch(PROXY + '/slots/release', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ slotId: slotId, cartToken: t })
      });
    }).catch(warn);
  }
  function updateCart(attrs) {
    return fetch((root.routes && root.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function absorbReply(body) {
    var attrs = {};
    BRAIN_ATTRS.forEach(function (k) { attrs[k] = body.attributes[k] == null ? '' : String(body.attributes[k]); });
    attrs.dn_slot_cartons = String(body.cartons || state.cartons || '');
    return attrs;
  }

  /** Ask for the days. Sets state.brain: 'ok' on a list of days (or a named postal error), 'down' on anything else. */
  function load(postal) {
    state.postal = postal;
    return getSlots({ postal: postal, cartons: Math.max(1, state.cartons) }).then(function (r) {
      if (r.status === 200 && r.body && Array.isArray(r.body.days)) {
        state.brain = 'ok'; state.offer = offer(r.body); state.postalError = '';
        var f = firstOpen(state.offer, state.attrs.dn_slot_id); state.dayIndex = f.dayIndex; state.slotId = f.slotId;
        return state.offer;
      }
      if ((r.status === 400 || r.status === 404) && r.body && r.body.error) {
        state.brain = 'ok'; state.offer = null; state.postalError = r.body.message || 'We do not recognise that postal code. Check the six digits.';
        return null;
      }
      state.brain = 'down'; state.offer = null; return null;
    }, function () { state.brain = 'down'; state.offer = null; return null; });
  }
  /** No postal code yet: learn whether the Brain is up without one (zone=collect needs none). */
  function probe() {
    return getSlots({ zone: 'collect', cartons: 1 }).then(function (r) {
      state.brain = r.status === 200 && r.body && Array.isArray(r.body.days) ? 'ok' : 'down';
    }, function () { state.brain = 'down'; });
  }

  /* ---------- render: the row ---------- */
  function setMsg(text) { var el = $('[data-dn-slot-msg]'); if (el) el.textContent = text || ''; }
  /**
   * Two lines. The slot line comes and goes with the Brain; the driver notes are always there, because they
   * are cart attributes and need nothing from the Brain (8 Sep 2026: "always visible, drawer too").
   * The block itself shows as soon as this file runs: with JS off it stays hidden and the cart still checks out.
   */
  function renderRow() {
    var b = block(); if (!b) return;
    var a = state.attrs, mode = rowMode(a, state.brain, state.offer, state.postal);
    state.mode = mode;
    b.hidden = false;
    b.setAttribute('data-state', mode);

    var slotTile = $('[data-dn-slot-line="slot"]', b);
    var offering = mode === 'held' || mode === 'offered';
    if (slotTile) {
      slotTile.hidden = !offering;
      var label = $('[data-dn-slot-label]', b), hold = $('[data-dn-slot-hold]', b);
      if (mode === 'held') {
        label.textContent = a.dn_slot_label;
        hold.textContent = remainingMs(a.dn_hold_expires_at, Date.now()) > 0 ? 'Held until ' + clock(a.dn_hold_expires_at) : '';
      } else {
        label.textContent = 'Choose';
        hold.textContent = '';
      }
      slotTile.setAttribute('aria-label', mode === 'held' ? 'Delivery slots: ' + a.dn_slot_label + '. Change it.' : 'Choose a delivery slot');
    }

    var det = $('[data-dn-slot-details]', b), notesTile = $('[data-dn-slot-line="notes"]', b);
    var have = detailsText(a);
    if (det) det.textContent = have || 'Add';
    if (notesTile) notesTile.setAttribute('aria-label', have ? 'Delivery notes: ' + have + '. Change them.' : 'Add delivery notes');
  }

  /* ---------- render: the sheet ---------- */
  function setMsg1(text) { var el = $('[data-dn-slot-msg1]'); if (el) el.textContent = text || ''; }
  function setMsg2(text) { var el = $('[data-dn-slot-msg2]'); if (el) el.textContent = text || ''; }
  function showStep(n) {
    var s = sheet(); if (!s) return;
    $$('[data-dn-slot-step]', s).forEach(function (el) { el.hidden = el.getAttribute('data-dn-slot-step') !== String(n); });
    /* Drawer -> Delivery Slots -> Delivery Notes -> Check out (12 Sep 2026): the same two steps, but
       the last button pays instead of just saving, and step 1 offers a way past. */
    var skip = $('[data-dn-slot-skip]', s); if (skip) skip.hidden = !(n === 1 && state.checkoutAfter);
    var conf = $('[data-dn-slot-confirm]', s); if (conf) conf.textContent = state.checkoutAfter ? 'Check out' : 'Confirm';
    var focus = n === 2 ? $('[data-dn-slot-title2]', s) : ($('[data-dn-slot-chip][aria-pressed="true"]', s) || $('#dn-slot-title', s));
    if (focus) focus.focus();
  }
  function postalStep(show, message) {
    var s = sheet(); if (!s) return;
    var f = $('[data-dn-slot-postal]', s); if (f) f.hidden = !show;
    $$('[data-dn-slot-chips], [data-dn-slot-rows], [data-dn-slot-to]', s).forEach(function (el) { el.hidden = show; });
    var change = $('[data-dn-slot-postal-change]', s); if (change) change.hidden = show;
    var msg = $('[data-dn-slot-postal-msg]', s); if (msg) msg.textContent = message || '';
    var cont = $('[data-dn-slot-continue]', s); if (cont) cont.disabled = show || !state.slotId;
    if (show && f) { var input = f.querySelector('input'); if (input) { input.value = state.postal || ''; input.focus(); } }
  }
  function renderSheet() {
    var s = sheet(), o = state.offer; if (!s) return;
    var to = $('[data-dn-slot-to]', s);
    if (to) {
      var area = '';
      try { var c = root.dnPostal && root.dnPostal.compute(state.postal || ''); if (c && c.ok && c.area) area = c.area; } catch (e) { /* no header script */ }
      to.textContent = 'Deliver to ' + (area ? area + ' (' + state.postal + ')' : (state.postal || '')) + (o && o.driverNote ? '. ' + o.driverNote : '');
    }
    var chips = $('[data-dn-slot-chips]', s), rows = $('[data-dn-slot-rows]', s);
    if (!o) { chips.innerHTML = ''; rows.innerHTML = ''; return; }
    /* "No preference" first, then the days as a calendar (10 Sep 2026: "No Preference
       should be placed on top of calender"). The option itself dates from 11 Sep: the slot has been
       optional since S4-05 - a cart with no slot attributes checks out on the 3-5 working day
       promise - but nothing on the sheet said so. NOPREF is its day index.
       Toggle buttons (aria-pressed) in a table rather than tabs: a tab has to live in a tablist,
       and a month grid is not one. One roving tab stop across all of them; the arrow keys move it. */
    var weeks = calendarWeeks(o.days);
    var spans = weeks.length && weeks[0][0].month !== weeks[weeks.length - 1][6].month;
    function pressable(i, cls, inner, label) {
      var on = i === state.dayIndex;
      return '<button type="button" class="' + cls + '" aria-pressed="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-dn-slot-chip="' + i + '"' + (label ? ' aria-label="' + esc(label) + '"' : '') + '>' + inner + '</button>';
    }
    chips.innerHTML =
      pressable(NOPREF, 'dn-sheet__nopref-btn', '<strong>No preference</strong><span>Within 3–5 working days</span>') +
      '<table class="dn-cal"><caption class="dn-cal__title">' + esc(calendarTitle(weeks)) + '</caption>' +
      '<thead><tr>' + [1, 2, 3, 4, 5, 6, 0].map(function (w) {
        return '<th scope="col" abbr="' + LONG_DAYS[w] + '"' + (w === 0 ? ' class="dn-cal__sun"' : '') + '>' + DAYS[w] + '</th>';
      }).join('') + '</tr></thead><tbody>' +
      weeks.map(function (week) {
        return '<tr>' + week.map(function (c) {
          // The 1st of a month carries its name when the grid spans two, so "1" never reads as a repeat.
          var text = c.date + (spans && c.date === 1 ? ' <small>' + MONTHS[c.month] + '</small>' : '');
          if (c.index < 0) {
            return '<td><span class="dn-cal__day dn-cal__day--off' + (c.weekday === 0 ? ' dn-cal__day--sun' : '') + '">' + text +
              '<span class="dn-visually-hidden">, no delivery</span></span></td>';
          }
          return '<td>' + pressable(c.index, 'dn-cal__day', text, dayLongLabel(c.day)) + '</td>';
        }).join('') + '</tr>';
      }).join('') + '</tbody></table>';
    if (state.dayIndex === NOPREF) {
      rows.innerHTML = '<p class="dn-meta dn-sheet__nopref">Leave it to us and we deliver within 3–5 working days, Monday to Saturday. We pick the earliest van going your way.</p>';
      var cN = $('[data-dn-slot-continue]', s); if (cN) cN.disabled = false;
      return;
    }
    var day = o.days[state.dayIndex];
    rows.innerHTML = day ? day.slots.map(function (sl) {
      var on = sl.canHold, checked = state.slotId === sl.id;
      return '<label class="dn-sheet__opt' + (on ? '' : ' dn-sheet__opt--off') + (checked ? ' is-checked' : '') + '">' +
        '<input type="radio" name="dn-slot-window" value="' + esc(sl.id) + '"' + (on ? '' : ' disabled') + (checked ? ' checked' : '') + '>' +
        '<span class="dn-sheet__opt-text">' + esc(sl.window) + '</span>' +
        (on ? '' : '<span class="dn-sheet__opt-right">Not available</span>') +
        '</label>';
    }).join('') : '<p class="dn-meta dn-muted">No windows on this day.</p>';
    var cont = $('[data-dn-slot-continue]', s); if (cont) cont.disabled = !state.slotId;
  }
  function fillStep2() {
    var s = sheet(), p = state.pending; if (!s || !p) return;
    var echo = $('[data-dn-slot-echo]', s); if (echo) echo.textContent = p.attributes.dn_slot_label || '';
    var note = $('[data-dn-slot-echo-note]', s); if (note) note.textContent = state.offer && state.offer.driverNote ? state.offer.driverNote : '';
    var a = state.attrs;
    var earlier = $('[name="dn_allow_earlier"]', s); if (earlier) earlier.checked = a.dn_allow_earlier === 'yes';
    var leave = $('[name="dn_note_leave"]', s); if (leave) leave.checked = a.dn_note_leave === 'yes';
    var lift = $('[name="dn_note_lift"]', s); if (lift) lift.checked = a.dn_note_lift === 'none';
    var bay = $('[name="dn_note_bay"]', s); if (bay) bay.value = a.dn_note_bay || '';
    var hours = $('[name="dn_note_hours"]', s); if (hours) hours.value = a.dn_note_hours || '';
    setMsg2('');
  }

  /* ---------- open, choose, hold, confirm ---------- */
  function open(opener) {
    var s = sheet(); if (!s || typeof s.showModal !== 'function') return;
    state.opener = opener || null; state.pending = null; state.notesOnly = false;
    setMsg1(''); setMsg('');
    if (!s.open) s.showModal();
    document.body.classList.add('dn-sheet-open');
    if (state.mode === 'notes') { notesStep(opener); return; }
    showStep(1);
    var rows = $('[data-dn-slot-rows]', s); if (rows) rows.innerHTML = '<p class="dn-meta dn-muted">Checking the days…</p>';
    var p = savedPostal();
    if (!p) { postalStep(true, ''); return; }
    postalStep(false, '');
    load(p).then(function () {
      renderRow();
      if (state.mode === 'notes') { notesStep(state.opener); return; }
      if (!state.offer) { postalStep(true, state.postalError); return; }
      renderSheet(); showStep(1);
    });
  }
  /**
   * The details step on its own, from the notes line: no hold is taken and Confirm writes only the notes.
   * It echoes the slot the cart already has, if any, so the shopper sees what the notes belong to; otherwise
   * the promise stands in its place. No Back, because there is no step one to go back to.
   */
  function notesStep(opener) {
    var s = sheet(); if (!s || typeof s.showModal !== 'function') return;
    state.opener = opener || null;
    state.pending = null;
    state.notesOnly = true;
    if (!s.open) s.showModal();
    document.body.classList.add('dn-sheet-open');
    fillStep2();
    var held = state.attrs.dn_slot_label;
    var echo = $('[data-dn-slot-echo]', s); if (echo) echo.textContent = held || 'Delivered within 3–5 working days';
    var note = $('[data-dn-slot-echo-note]', s);
    if (note) note.textContent = held ? '' : (state.mode === 'offered' ? 'No slot chosen. Choose one on the basket if you want a window.' : 'Slot choice opens when we open the delivery windows.');
    var back = $('[data-dn-slot-back]', s); if (back) back.hidden = true;
    var foot = back && back.parentElement; if (foot) foot.classList.add('dn-sheet__foot--one');
    showStep(2);
  }
  function close() {
    var s = sheet();
    // Continue took a hold and the shopper left without confirming: give that window back now.
    if (state.pending && state.pending.slotId) { postRelease(state.pending.slotId); state.pending = null; }
    if (s && s.open) s.close();
    document.body.classList.remove('dn-sheet-open');
    /*
     * Give focus back to whatever opened the sheet - WCAG 2.4.3: closing a dialog must not drop focus on
     * the body. The cart write can re-render the row underneath the sheet, which detaches the element we
     * opened from, so the old `document.contains` check simply gave up and focus was lost. Re-find the
     * live tile by its line instead. (Same detached-node trap as proceedToCheckout above; found by the
     * slot-picker test on 12 Sep 2026, its first run since the retired handle broke this file.)
     */
    var opener = state.opener;
    if (opener && !opener.isConnected) {
      var line = opener.getAttribute && opener.getAttribute('data-dn-slot-line');
      opener = line ? $('[data-dn-slot-line="' + line + '"]') : null;
    }
    if (opener && opener.focus && opener.isConnected) opener.focus();
    state.opener = null;
    // Cancel is a back-out, not a purchase: leaving the sheet never carries on to checkout.
    state.checkoutAfter = false; state.checkoutButton = null;
  }

  /**
   * Step 2's button when the sheet was opened by the drawer's Check out. The attributes are already
   * saved by the time this runs. requestSubmit keeps the real submitter, so the form posts with
   * name="checkout" exactly as the plain button would; the location fallback is for browsers without it.
   */
  function proceedToCheckout(btn) {
    state.checkoutAfter = false; state.checkoutButton = null;
    /*
     * The cart write that just ran makes dn-cart.js re-render the drawer, which DETACHES the button we
     * captured when Check out was pressed. A detached button still reports its form, and requestSubmit
     * on a disconnected form throws - inside doConfirm's promise, where .catch turns it into "We could
     * not save that. Try again." over a save that had in fact succeeded, and no checkout. Found by the
     * Playwright test on 12 Sep 2026; a hand-click missed it because the re-render does not always land
     * before the click resolves, which is the worst kind of intermittent.
     *
     * So: re-find the live button, and treat a throw as a reason to navigate rather than to give up.
     */
    var live = btn && btn.isConnected ? btn : $('.dn-drawer [data-dn-checkout]');
    var form = live && live.isConnected ? live.form : null;
    if (form && form.isConnected && typeof form.requestSubmit === 'function') {
      try { form.requestSubmit(live); return; } catch (e) { warn(e); }
    }
    root.location.href = '/checkout';
  }

  /**
   * "Skip - deliver in 3-5 working days" on step 1. Goes to the notes with no slot, which is the state
   * dn-cart-validation tolerates. Back stays available, unlike the notes-only entry, because there IS a
   * step one to go back to here.
   */
  function notesAfterSkip() {
    var s = sheet(); if (!s) return;
    state.pending = null; state.notesOnly = false; state.noPref = true;
    fillStep2();
    var echo = $('[data-dn-slot-echo]', s); if (echo) echo.textContent = 'Delivered within 3–5 working days';
    var note = $('[data-dn-slot-echo-note]', s); if (note) note.textContent = 'No particular day. You can still add notes for the driver.';
    var back = $('[data-dn-slot-back]', s);
    if (back) { back.hidden = false; if (back.parentElement) back.parentElement.classList.remove('dn-sheet__foot--one'); }
    showStep(2);
  }
  /** The "No preference" chip's day index. -1 can never collide with a real day. */
  var NOPREF = -1;
  function selectDay(i) {
    state.dayIndex = i;
    // No preference holds nothing, so any slot chosen a moment ago stops being wanted.
    if (i === NOPREF) state.slotId = null;
    else {
      var day = state.offer && state.offer.days[i];
      if (!day || !day.slots.some(function (s) { return s.id === state.slotId; })) state.slotId = null;
    }
    renderSheet();
    var chip = $('[data-dn-slot-chip][aria-pressed="true"]'); if (chip) chip.focus();
  }
  function submitPostal(form) {
    var input = form.querySelector('input[name="postal"]');
    var v = (input.value || '').replace(/\D/g, '');
    if (v.length !== 6) { input.setCustomValidity('Six digits, like 730123'); input.reportValidity(); return; }
    input.setCustomValidity('');
    savePostal(v);
    var rows = $('[data-dn-slot-rows]'); if (rows) rows.innerHTML = '<p class="dn-meta dn-muted">Checking the days…</p>';
    load(v).then(function () {
      if (state.brain !== 'ok') { close(); renderRow(); return; }
      if (!state.offer) { postalStep(true, state.postalError); return; }
      if (!state.offer.days.length) { postalStep(true, 'No slots to offer for that postal code right now. We still deliver within 3–5 working days.'); return; }
      postalStep(false, ''); renderSheet(); showStep(1);
      document.dispatchEvent(new CustomEvent('dn:slot:postal', { detail: { postal: v } }));
    });
  }
  function doContinue() {
    var s = sheet(); var btn = $('[data-dn-slot-continue]', s);
    /* No preference takes no hold, so there is nothing to ask the Brain for and nothing that can
       fail: straight to the details step, where doConfirm blanks the slot attributes. Going through
       postHold would reserve capacity for a shopper who has just said they do not want a slot. */
    if (state.dayIndex === NOPREF) {
      if (!btn || btn.disabled) return;
      state.pending = null; state.noPref = true; setMsg1(''); fillStep2();
      var backN = $('[data-dn-slot-back]', s); if (backN) { backN.hidden = false; if (backN.parentElement) backN.parentElement.classList.remove('dn-sheet__foot--one'); }
      showStep(2); return;
    }
    state.noPref = false;
    if (!state.slotId || !btn || btn.disabled) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); setMsg1('');
    postHold(state.slotId, state.cartons).then(function (r) {
      btn.removeAttribute('aria-busy');
      if (r.status === 200 && r.body && r.body.attributes) {
        state.pending = r.body; fillStep2();
        var back = $('[data-dn-slot-back]', s); if (back) { back.hidden = false; if (back.parentElement) back.parentElement.classList.remove('dn-sheet__foot--one'); }
        showStep(2); return;
      }
      btn.disabled = false;
      if (r.status === 503 || !r.body) { setMsg1('We could not reach our delivery desk just now. Check out anyway and we deliver within 3–5 working days.'); return; }
      setMsg1(reasonText(r.body.error));
      return load(state.postal).then(function () { renderSheet(); });
    }).catch(function (e) { warn(e); btn.removeAttribute('aria-busy'); btn.disabled = false; setMsg1('Something went wrong. Try again.'); });
  }
  function doConfirm() {
    var s = sheet(), p = state.pending, btn = $('[data-dn-slot-confirm]', s);
    /* close() clears both, and it runs before either is used below, so read them here. */
    var wantCheckout = state.checkoutAfter, checkoutBtn = state.checkoutButton;
    var previousSlotId = state.attrs.dn_slot_id || '';
    if (!btn || btn.disabled) return;
    if (!p && !state.notesOnly && !state.noPref) return; // opened from the notes line: the details are the whole errand
    var attrs = p ? absorbReply(p) : {};
    if (p) attrs.dn_postal = state.postal || '';
    /* No preference: blank every slot attribute, which is the state dn-cart-validation tolerates -
       a cart carrying none of them checks out on the 3-5 working day promise (S4-05). The driver
       notes below are kept: wanting no particular day says nothing about the doorstep. */
    if (state.noPref) {
      BRAIN_ATTRS.concat(['dn_slot_cartons']).forEach(function (k) { attrs[k] = ''; });
      attrs.dn_postal = state.postal || '';
    }
    var earlier = $('[name="dn_allow_earlier"]', s), leave = $('[name="dn_note_leave"]', s), lift = $('[name="dn_note_lift"]', s), bay = $('[name="dn_note_bay"]', s), hours = $('[name="dn_note_hours"]', s);
    attrs.dn_allow_earlier = earlier && earlier.checked ? 'yes' : '';
    attrs.dn_note_leave = leave && leave.checked ? 'yes' : '';
    attrs.dn_note_lift = lift && lift.checked ? 'none' : '';
    attrs.dn_note_bay = bay ? (bay.value || '').trim().slice(0, 120) : '';
    attrs.dn_note_hours = hours ? (hours.value || '').trim().slice(0, 60) : '';
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); setMsg2('');
    updateCart(attrs).then(function () {
      btn.disabled = false; btn.removeAttribute('aria-busy');
      /* Same trap one line down: announce() below reads noPref, and this clears it. Until 12 Sep 2026
         the "no preference" announcement could therefore never fire - the screen reader heard
         "Notes for the driver saved" instead. */
      var wasNoPref = state.noPref;
      state.attrs = Object.assign({}, state.attrs, attrs); writeInputs(attrs); state.pending = null; state.noPref = false;
      // Moved to another window: the one held before is no longer wanted.
      if (previousSlotId && previousSlotId !== attrs.dn_slot_id) postRelease(previousSlotId);
      close(); renderRow(); armExpiry();
      announce(wasNoPref ? 'No delivery preference saved. We deliver within 3–5 working days.' : (p ? 'Delivery slot saved: ' + attrs.dn_slot_label : 'Notes for the driver saved'));
      document.dispatchEvent(new CustomEvent('dn:slot', { detail: attrs }));
      if (wantCheckout) proceedToCheckout(checkoutBtn);
    }).catch(function (e) { warn(e); btn.disabled = false; btn.removeAttribute('aria-busy'); setMsg2('We could not save that. Try again.'); });
  }
  function clearSlot(message) {
    var attrs = {};
    BRAIN_ATTRS.concat(['dn_slot_cartons']).forEach(function (k) { attrs[k] = ''; });
    return updateCart(attrs).then(function () {
      state.attrs = Object.assign({}, state.attrs, attrs); writeInputs(attrs);
      renderRow(); setMsg(message); announce(message);
      document.dispatchEvent(new CustomEvent('dn:slot', { detail: attrs }));
    }).catch(warn);
  }
  /** Ask the Brain again for the slot on the cart: the cartons changed, or the hold ran out. */
  function rehold(why) {
    var a = state.attrs;
    if (!held(a)) return Promise.resolve();
    if (state.brain === 'down') return why === 'expired' ? clearSlot('Your slot hold ran out. Choose again.') : Promise.resolve();
    if (state.cartons < 1) return Promise.resolve();
    return postHold(a.dn_slot_id, state.cartons).then(function (r) {
      if (r.status === 200 && r.body && r.body.attributes) {
        var attrs = absorbReply(r.body);
        return updateCart(attrs).then(function () { state.attrs = Object.assign({}, state.attrs, attrs); writeInputs(attrs); renderRow(); setMsg(''); armExpiry(); });
      }
      if (r.status === 503 || !r.body) { state.brain = 'down'; renderRow(); return; }
      return clearSlot(why === 'cartons'
        ? 'Your basket changed and that window has no room for it now. Choose another slot.'
        : 'Your slot hold ran out. Choose again.');
    }).catch(warn);
  }
  function armExpiry() {
    if (expiryTimer) clearTimeout(expiryTimer);
    expiryTimer = null;
    if (!held(state.attrs)) return;
    var ms = remainingMs(state.attrs.dn_hold_expires_at, Date.now());
    if (ms <= 0) { rehold('expired'); return; }
    expiryTimer = setTimeout(function () { expiryTimer = null; rehold('expired'); }, Math.min(ms, 2147483647));
  }

  /* ---------- events ---------- */
  function onClick(e) {
    /* The drawer's Check out is the entry to the two steps (12 Sep 2026). Only the drawer's: the cart
       page keeps its tiles and its Check out goes straight to pay. If the sheet cannot open - no
       <dialog>, or this file never ran - nothing is intercepted and the plain submit stands, which is
       what keeps the basket checking out with the Brain down. */
    var co = e.target.closest && e.target.closest('[data-dn-checkout]');
    /* ADR-044: a basket of e-vouchers alone has nothing to deliver; its Check out goes straight to pay. */
    if (co && co.closest('.dn-drawer') && !co.hasAttribute('data-dn-no-delivery')) {
      var sh = sheet();
      if (sh && typeof sh.showModal === 'function') {
        e.preventDefault();
        state.checkoutAfter = true; state.checkoutButton = co;
        open(co);
        return;
      }
    }
    var t = e.target.closest('[data-dn-slot-open], [data-dn-slot-notes], [data-dn-slot-cancel], [data-dn-slot-chip], [data-dn-slot-continue], [data-dn-slot-back], [data-dn-slot-confirm], [data-dn-slot-postal-change], [data-dn-slot-skip]');
    if (!t) return;
    if (t.hasAttribute('data-dn-slot-open')) { e.preventDefault(); open(t); return; }
    if (t.hasAttribute('data-dn-slot-notes')) { e.preventDefault(); setMsg(''); notesStep(t); return; }
    if (t.hasAttribute('data-dn-slot-cancel')) { close(); return; }
    if (t.hasAttribute('data-dn-slot-chip')) { selectDay(Number(t.getAttribute('data-dn-slot-chip'))); return; }
    if (t.hasAttribute('data-dn-slot-continue')) { doContinue(); return; }
    if (t.hasAttribute('data-dn-slot-back')) { state.noPref = false; showStep(1); return; }
    if (t.hasAttribute('data-dn-slot-skip')) { notesAfterSkip(); return; }
    if (t.hasAttribute('data-dn-slot-confirm')) { doConfirm(); return; }
    if (t.hasAttribute('data-dn-slot-postal-change')) { postalStep(true, ''); }
  }
  function onChange(e) {
    var t = e.target;
    if (t.name === 'dn-slot-window') { state.slotId = t.value; $$('input[name="dn-slot-window"]').forEach(function (r) { var l = r.closest('.dn-sheet__opt'); if (l) l.classList.toggle('is-checked', r.checked); }); var c = $('[data-dn-slot-continue]'); if (c) c.disabled = false; return; }
  }
  function onSubmit(e) { var f = e.target.closest && e.target.closest('[data-dn-slot-postal]'); if (!f) return; e.preventDefault(); submitPostal(f); }
  function onKey(e) {
    var t = e.target;
    if (!t.hasAttribute || !t.hasAttribute('data-dn-slot-chip')) return;
    var next = arrowTarget(state.offer ? state.offer.days : [], state.dayIndex, e.key);
    if (next === undefined) return;
    e.preventDefault();
    if (next !== state.dayIndex) selectDay(next);
  }
  function onCart(ev) {
    var d = ev && ev.detail ? ev.detail : {};
    if (typeof d.vanCartons === 'number') state.cartons = d.vanCartons; // ADR-025: partner cartons hold no slot
    else if (typeof d.cartons === 'number') state.cartons = d.cartons;
    if (!started) { start(); return; }
    var fresh = readAttrs(); if (Object.keys(fresh).length) state.attrs = Object.assign({}, state.attrs, fresh);
    renderRow();
    if (!needsRehold(state.attrs, state.cartons)) return;
    if (reholdTimer) clearTimeout(reholdTimer);
    reholdTimer = setTimeout(function () { reholdTimer = null; if (needsRehold(state.attrs, state.cartons)) rehold('cartons'); }, 600);
  }
  function onDialogClose() { document.body.classList.remove('dn-sheet-open'); }

  /* The row is in the cart page's summary and in the drawer's; on a page whose basket was empty it only
     arrives with the drawer's re-render after the first add, so the listeners bind at load and the first
     Brain call waits for a row to exist. */
  var started = false;
  function start() {
    if (started || !block()) return;
    started = true;
    state.attrs = readAttrs(); state.cartons = cartonsNow();
    renderRow(); // a slot already on the cart shows at once, Change waits for the Brain
    var p = savedPostal();
    (p ? load(p) : probe()).then(function () { renderRow(); armExpiry(); }, warn);
  }
  function boot() {
    function init() {
      document.addEventListener('click', onClick);
      document.addEventListener('change', onChange);
      document.addEventListener('submit', onSubmit);
      document.addEventListener('keydown', onKey);
      document.addEventListener('dn:cart', onCart);
      document.addEventListener('close', onDialogClose, true);
      // Escape raises 'cancel' then closes the dialog natively, which skipped close(): a held window was never
      // given back and focus was not returned. Route it through close() like the Cancel button (Sprint 8 pass).
      document.addEventListener('cancel', function (e) { if (e.target === sheet()) { e.preventDefault(); close(); } }, true);
      start();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  }

  return { dayLabel: dayLabel, calendarWeeks: calendarWeeks, calendarTitle: calendarTitle, dayLongLabel: dayLongLabel, arrowTarget: arrowTarget, offer: offer, firstOpen: firstOpen, held: held, needsRehold: needsRehold, detailsText: detailsText, remainingMs: remainingMs, clock: clock, reasonText: reasonText, rowMode: rowMode, esc: esc, boot: boot };
});
